module.exports = __webpack_public_path__ + "img/icon-customize-colored.c022ca01.svg";